import React from "react";
import styled from "styled-components";
import { unmodule } from "../../util";
import { ModalContext } from "../../providers/ProvideModal";
import { apiGet } from "../../api";

const UnnamedComponent = (props) => {
  const [hovered, setHovered] = React.useState(false);
  const [rules, setRules] = React.useState();
  const { openModal } = React.use(ModalContext);

  const openRules = React.useCallback((data) => {
    openModal({
      title: (
        <React.Fragment>
          Pengaturan Komisi Afiliator
          <PublishedAt>Per {data.comission_rule_last_updated_at}</PublishedAt>
        </React.Fragment>
      ),
      body: (
        <table>
          <thead>
            <tr>
              <th>Tipe</th>
              <th>Nama</th>
              <th>Komisi</th>
            </tr>
          </thead>
          <tbody>
            {data.comission_rules?.map((x) => (
              <tr key={`${x.type}-${x.name}`}>
                <td>{x.type}</td>
                <td>{x.name}</td>
                <td>{x.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ),
    });
  }, []);

  const handleClick = React.useCallback(async () => {
    if (rules) {
      openRules(rules);
    } else {
      const { parsedResponse, statusCode } = await apiGet(
        "/api/v1/users/affiliators/comission_rules",
      );
      if (statusCode === 200) {
        openRules(parsedResponse);
        setRules(parsedResponse);
      }
    }
  }, [rules]);

  return (
    <ComissionRuleDiv
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      onClick={handleClick}
    >
      <img
        src={
          hovered
            ? unmodule(require("../../images/icons/setting-orange.svg"))
            : unmodule(require("../../images/icons/setting.svg"))
        }
      />
      <span>Comission Rules</span>
    </ComissionRuleDiv>
  );
};

export default UnnamedComponent;

const ComissionRuleDiv = styled.div`
  align-items: center;
  border-radius: 4px;
  border: solid 1px #636363;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  padding: 6px 11px;

  &:hover,
  &:active,
  &:focus {
    background-color: #ffffff0a;
    color: var(--hovered-text-color);
    text-decoration: underline;
  }

  & > img {
    width: 20px;
  }

  & > span {
  }
`;

const PublishedAt = styled.span`
  color: #9f9f9f;
  font-size: 12px;
  margin: 0 5px;
  text-wrap: nowrap;
`;
